import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type Suggestion from 'src/types/Suggestion';

export type IPassportFilterState = {
  since__gte: string;
  since__lte: string;
  created_at__gte: string;
  created_at__lte: string;
  type_package: Suggestion[];
  organization: Suggestion[];
};

const initialState: IPassportFilterState = {
  since__lte: '',
  since__gte: '',
  created_at__gte: '',
  created_at__lte: '',
  type_package: [],
  organization: [],
};

type FilterAction = {
  organization?: Suggestion[];
  createdAtGte?: string,
  createdAtLte?: string,
  sinceGte?: string,
  sinceLte?: string,
  typePackage?: Suggestion[],
};

const slice = createSlice({
  name: 'passportsFilter',
  initialState,
  reducers: {
    setPassportsFilter(
      state: IPassportFilterState,
      action: PayloadAction<FilterAction>
    ) {
      const {
        organization,
        createdAtGte,
        createdAtLte,
        sinceGte,
        sinceLte,
        typePackage
      } = action.payload;

      state.since__gte = sinceGte;
      state.since__lte = sinceLte;
      state.organization = organization;
      state.organization.concat(organization);
      state.created_at__gte = createdAtGte;
      state.created_at__lte = createdAtLte;
      state.type_package = typePackage;
      state.type_package.concat(typePackage);
    },
    resetPassportFilter(
      state: IPassportFilterState,
    ) {
      state.organization = [];
      state.created_at__lte = '';
      state.created_at__gte = '';
      state.since__gte = '';
      state.since__lte = '';
      state.type_package = [];
    }
  }
});

export const { reducer } = slice;

export const {
  setPassportsFilter,
  resetPassportFilter
} = slice.actions;

export default slice;
